const BASE_URL = 'https://mall.qpsjq.com' // 正式 棋盘山
// const BASE_URL = 'https://jyt.tqingdao.com' // 正式 saas
// const BASE_URL = 'http://newticket.tqingdao.com' // 测试
const Config = {
  // 更换景区需要更改BASE_URL，APP_ID，APP_SECRET，SPOT_ID
  APP_ID: '10018',
  APP_SECRET: 'a506c199a0a516fd5725e9e19ae5dd11',
  API_VERSION: '1.0',
  CACHE_KEY_PREFIX: 'ticket_',
  SPOT_ID: 21,
  SOURCE: 6,
  MID: 2,
  uploadimg: { url: BASE_URL + '/api/v1/file/base64', needToken: true },
  login: { url: BASE_URL + '/api/distribution/v1/distribution-login/login', needToken: false },
  logout: { url: BASE_URL + '/api/distribution/v1/distribution-login/logout', needToken: true },
  spot_index: { url: BASE_URL + '/api/zzy-spot/citgroup/spot/index', needToken: true },
  spot_view: { url: BASE_URL + '/api/zzy-spot/citgroup/spot/view', needToken: true },
  ticket_view: { url: BASE_URL + '/api/zzy-spot/citgroup/ticket/view', needToken: true },
  ticket_price: { url: BASE_URL + '/api/zzy-spot/citgroup/ticket/ajax-get-ticket-price', needToken: true },
  order_create: { url: BASE_URL + '/api/zzy-spot/citgroup/order/create', needToken: true },
  order_pay: { url: BASE_URL + '/api/zzy-spot/citgroup/order/credit-pay', needToken: true },
  order_list: { url: BASE_URL + '/api/zzy-spot/citgroup/order/order-list', needToken: true },
  order_detail: { url: BASE_URL + '/api/zzy-spot/citgroup/order/detail', needToken: true },
  order_refund: { url: BASE_URL + '/api/zzy-spot/citgroup/order/refund', needToken: true },
  order_close: { url: BASE_URL + '/api/zzy-spot/citgroup/order/close', needToken: true },
  account: { url: BASE_URL + '/api/zzy-spot/citgroup/account/account', needToken: true },
  month_bill: { url: BASE_URL + '/api/zzy-spot/citgroup/bill/month-bill', needToken: true },
  bill_detail: { url: BASE_URL + '/api/zzy-spot/citgroup/bill/bill-detail', needToken: true },
  order_report: { url: BASE_URL + '/api/zzy-spot/citgroup/order/report', needToken: true },
  transaction_list: { url: BASE_URL + '/api/zzy-spot/citgroup/bill/transaction-list', needToken: true },
  repayment: { url: BASE_URL + '/api/zzy-spot/citgroup/bill/repayment', needToken: true },
  see_reason: { url: BASE_URL + '/api/zzy-spot/citgroup/bill/see-reason', needToken: true },
  get_order_num: { url: BASE_URL + '/api/zzy-spot/citgroup/order/get-order-num', needToken: true },
  distribution_info: { url: BASE_URL + '/api/distribution/v1/distribution/info', needToken: true },
  distribution_personal: { url: BASE_URL + '/api/distribution/v1/distribution/personal', needToken: true },
  up_password: { url: BASE_URL + '/api/distribution/v1/distribution/up-password', needToken: true },
  sms_code: { url: BASE_URL + '/api/distribution/v1/distribution/sms-code', needToken: true },
  register: { url: BASE_URL + '/api/distribution/v1/distribution/register', needToken: true },
  derive: { url: BASE_URL + '/api/zzy-spot/citgroup/order/export', needToken: true },

  ORDER_DETECT_INTERVAL: 1000,
  ORDER_STATE: [
    { name: '待确认', value: '0' },
    { name: '待付款', value: '1' },
    { name: '待消费', value: '2' },
    { name: '已关闭', value: '3' },
    { name: '已完成', value: '4' },
    { name: '退款中', value: '5' },
    { name: '已退款', value: '6' },
    { name: '已过期', value: '7' }
  ],
  PAY_STATE: [
    { name: '未还款', value: '1' },
    { name: '待审核', value: '2' },
    { name: '审核中', value: '3' },
    { name: '审核驳回', value: '4' },
    { name: '已还款', value: '5' }
  ],
  ENUM: {
    ORDER_WAIT_PAY: 1,
    ORDER_PAY_SUCCESS: 2
  },
  TEXT: {
    payCountdown: '您已支付，三秒后将跳转到打印页面'
  },

  HTTP_CODE: {
    200: 'OK',
    201: 'Created',
    202: 'Accepted',
    203: 'Non-Authoritative Information',
    204: 'No Content',
    205: 'Reset Content',
    206: 'Partial Content',
    207: 'Multi-Status',
    400: 'Bad Request',
    401: 'Unauthorized',
    402: 'Payment Required',
    403: 'Forbidden',
    404: 'Not Found',
    405: 'Method Not Allowed',
    406: 'Not Acceptable',
    407: 'Proxy Authentication Required',
    408: 'Request Timeout',
    409: 'Conflict',
    410: 'Gone',
    411: 'Length Required',
    412: 'Precondition Failed',
    413: 'Request Entity Too Large',
    414: 'Request-URI Too Long',
    415: 'Unsupported Media Type',
    416: 'Requested Range Not Satisfiable',
    417: 'Expectation Failed',
    418: 'I,m a teapot',
    421: 'Misdirected Request',
    422: 'Unprocessable Entity',
    423: 'Locked',
    424: 'Failed Dependency',
    425: 'Too Early',
    426: 'Upgrade Required',
    449: 'Retry With',
    451: 'Unavailable For Legal Reasons',
    500: 'Internal Server Error',
    501: 'Not Implemented',
    502: 'Bad Gateway',
    503: 'Service Unavailable',
    504: 'Gateway Timeout',
    505: 'HTTP Version Not Supported',
    506: 'Variant Also Negotiates',
    507: 'Insufficient Storage',
    509: 'Bandwidth Limit Exceeded',
    510: 'Not Extended',
    600: 'Unparseable Response Headers'
  }
}
export default Config



// WEBPACK FOOTER //
// ./src/components/utils/config.js